import * as React from 'react';
import { ArticleHeading1, Image, UIText1 } from '@cian/ui-kit';

import * as styles from './OnboardingSlideDesktop.css';

type TProps = {
  src: string;
  title: string;
  text: string;
};

export const OnboardingSlideDesktop: React.FC<TProps> = ({ src, title, text }) => {
  return (
    <div className={styles['container']} data-testid="OnboardingSlideDesktop">
      <div className={styles['image']}>
        <Image src={src} width={600} height={300} borderRadius={0} />
      </div>
      <div className={styles['content']}>
        <ArticleHeading1>{title}</ArticleHeading1>
        <UIText1>{text}</UIText1>
      </div>
    </div>
  );
};
